// extracted by mini-css-extract-plugin
export default {"count-block":"styles_count-block__QXh+-"};